import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const defaultinvoice = () => ({
  id : null,
  inv_number : null,
  customer : null,
  credit_notes : [],
  status : null,
  lines : [],
  currency : null,
  invoice_term : null,
  sent_at : null,
})

const getDefaultState = () => ({
  invoices : [],
  selectedInvoice : defaultinvoice(),
  selectedInvoiceHistoricActivities : [],
  selectedIndex : null,
  orderBy:{orderName : 'created_at',  direction:'DESC'},
  outDated : true,
  loading : false,
  loadingInvoice : false,
  mode : 'tile',
  searchTerms :'',
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  page : 1,
  pages : 0, //nombre de page total
  count : 0,
  limit : 50,
  filters : {
    status : [],
    date : null,
    checkedCustomerClasses : [],
    checkedInvoiced : [],
    checkedReps : [],
    withoutReps : false,
    customerId : null,
    productId : null,
    paidAt : null
  },
  invoiceDownloading : false,

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
